import { normalize } from 'normalizr';

import { partFileSchema, printPageSchema } from './entities';

export const types = {
  RECEIVE_ACTIVE_PART_FILE_UUID: 'common/viewer/RECEIVE_ACTIVE_PART_FILE_UUID',
  RECEIVE_PAGE_VECTORIZATION: 'common/viewer/RECEIVE_PAGE_VECTORIZATION',
  RECEIVE_PART_FILE: 'common/viewer/RECEIVE_PART_FILE',
  RECEIVE_PRINT_PAGE: 'common/viewer/RECEIVE_PRINT_PAGE',
  RECEIVE_PART_FILES: 'common/viewer/RECEIVE_PART_FILES',
  RESET: 'common/viewer/RESET',
};

export const viewer = {
  receiveActivePartFileUuid: ({
    partFileUuid,
    shouldFocus,
    shouldPropagateVisibility,
    ignoreQueue,
  }: {
    partFileUuid: string;
    shouldFocus: boolean;
    shouldPropagateVisibility: boolean;
    ignoreQueue?: boolean;
  }) => ({
    type: types.RECEIVE_ACTIVE_PART_FILE_UUID,
    payload: {
      partFileUuid,
      shouldFocus,
      shouldPropagateVisibility,
      ignoreQueue,
    },
  }),
  receivePageVectorization: ({ pageIdToVectorization }) => ({
    type: types.RECEIVE_PAGE_VECTORIZATION,
    payload: { pageIdToVectorization },
  }),
  receivePartFiles: ({ partFiles }) => ({
    type: types.RECEIVE_PART_FILES,
    payload: normalize(partFiles, [partFileSchema]),
  }),
  receivePartFile: ({ file }) => ({
    type: types.RECEIVE_PART_FILE,
    payload: {
      ...normalize(file, partFileSchema),
    },
  }),
  receivePrintPage: ({ printPage }) => ({
    type: types.RECEIVE_PRINT_PAGE,
    payload: {
      ...normalize(printPage, printPageSchema),
    },
  }),
  reset: () => ({
    type: types.RESET,
  }),
};
